module.exports = __webpack_public_path__ + "static/media/7s.a97f2eb4.png";